<template>
    <creams-form @submit="onSubmit" @delete="onDelete"
      :cream="cream" :alert="alert">
    </creams-form>
  </div>
</template>

<script>
import flash from '../../../services/flash'
import creamsForm from './_form'

export default {
  components: { creamsForm },

  data () {
    return {
      cream: {},
      alert: {}
    }
  },

  created () {
    const id = this.$route.params.id
    this.$http.get(`/api/creams/${id}`)
      .then(res => {
        this.cream = res.body.cream
      })
      .catch(reason => console.log(reason))
  },

  methods: {
    onSubmit ({cream, form}) {
      if (!cream.id) throw new Error('Missing id')
      this.$http.post(`/api/creams/${cream.id}`, form)
        .then(() => {
          flash.set({
            type: 'info',
            message: `Sorte ${cream.name} aktualisiert`
          })
          this.$router.push('/creams')
        })
        .catch((reason) => {
          if (!reason.body.errors) return console.log(reason)
          this.alert = flash.now({
            type: 'danger',
            code: reason.body.errors[0],
            data: {
              name: cream.name
            }
          })
        })
    },

    onDelete (cream) {
      if (!cream.id) throw new Error('Missing id')
      this.$http.delete(`/api/creams/${cream.id}`, {cream})
        .then(() => {
          flash.set({
            type: 'warning',
            message: `Sorte ${cream.name} gelöscht`
          })
          this.$router.push('/creams')
        })
        .catch(reason => console.log(reason))
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// edit.vue?02e0fe06